export default {
  title: 'Tasse e valuta',
  subtitle: 'Gestisci le categorie fiscali usate per i prezzi delle voci di menu.',
};
